import { useRouteLoaderData } from 'react-router';
import type { RootLoaderData } from '~/root';

/** The storefront's VAT-display preference. `true` → show VAT-inclusive
 *  (gross) prices; `false` (default) → show VAT-exclusive (net) prices with an
 *  "excl. VAT" indication. Read from the root loader (present on every page). */
export function useIncludeTaxInPrices(): boolean {
  const root = useRouteLoaderData<RootLoaderData>('root');
  return root?.preferences.includeTaxInPrices ?? false;
}
